// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__12-ol","dragIcon":"Choice_dragIcon__3VJY1","left":"Choice_left__1SQcg","input":"Choice_input__255lr"};